import { render } from "./ActiveDetail.vue?vue&type=template&id=22f45a72&ts=true"
import script from "./ActiveDetail.vue?vue&type=script&lang=ts"
export * from "./ActiveDetail.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__